(() => {
  const init = (root = document) => {
    root.querySelectorAll('.aq-header').forEach((header) => {
      const toggle = header.querySelector('.aq-mobile-menu');
      const nav = header.querySelector('.aq-navigation');
      if (!toggle || !nav || header.classList.contains('aq-mobile-ready')) return;
      header.classList.add('aq-mobile-ready');
      const setOpen = (open, focus = false) => {
        header.classList.toggle('aq-mobile-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        if (!open) nav.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
        if (focus) toggle.focus();
      };
      toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && header.classList.contains('aq-mobile-open')) {
          event.stopPropagation();
          setOpen(false, true);
        }
      });
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) setOpen(false);
      });
      window.matchMedia('(min-width: 750px)').addEventListener('change', event => {
        if (event.matches) setOpen(false);
      });
    });
    root.querySelectorAll('.aq-navigation').forEach((nav) => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const menus = [...nav.querySelectorAll('details')];
      const close = (menu, focus = false) => {
        menu.open = false;
        menu.querySelector('summary').setAttribute('aria-expanded', 'false');
        if (focus) menu.querySelector('summary').focus();
      };
      menus.forEach((menu) => {
        const summary = menu.querySelector('summary');
        summary.setAttribute('aria-expanded', 'false');
        menu.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(menu.open));
          if (menu.open) menus.filter((other) => other !== menu).forEach((other) => close(other));
          const header = nav.closest('sticky-header');
          if (header) header.preventHide = menus.some((item) => item.open);
        });
        menu.querySelector('button').addEventListener('click', () => close(menu, true));
      });
      nav.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') menus.filter((menu) => menu.open).forEach((menu) => close(menu, true));
      });
      document.addEventListener('click', (event) => {
        if (!nav.contains(event.target)) menus.forEach((menu) => close(menu));
      });
      nav.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!nav.contains(document.activeElement)) menus.forEach((menu) => close(menu));
        });
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
